<template>
  <div
    class="flex flex-col mb-10"
    v-touch:swipe.left="toRight"
    v-touch:swipe.right="toLeft"
  >
    <div>
      <div class="leading-60px text-16px text-qwraybright tracking-2.4px">
        {{ $t('our_product.small_header') }}
      </div>
      <div class="text-white font-Foco text-30px">
        {{ $t('our_product.big_header') }}
      </div>
    </div>
    <div
      class="flex flex-row justify-between text-center items-center -mx-5 mt-4"
    >
      <div class="w-1/8">
        <div class="arrow" @click="toLeft()">
          <svg
            class="arr-wd ml-2"
            style="transform: scaleX(-1);"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 22.627 22.627"
          >
            <path
              v-bind:class="first() ? 'arr-disabled' : ''"
              class="arr"
              d="M0,0H14V14"
              transform="translate(11.314 1.414) rotate(45)"
            />
          </svg>
        </div>
      </div>
      <div class="w-1/2 sm:w-auto text-center">
        <picture>
          <source type="image/webp" :srcset="require('@/' + webP)" />
          <source type="image/jpeg" :srcset="image" />
          <img :src="image" />
        </picture>
      </div>
      <div class="w-1/8">
        <div class="arrow items-center" @click="toRight()">
          <svg
            class="arr-wd ml-1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 22.627 22.627"
          >
            <path
              v-bind:class="last() ? 'arr-disabled' : ''"
              class="arr"
              d="M0,0H14V14"
              transform="translate(11.314 1.414) rotate(45)"
            />
          </svg>
        </div>
      </div>
    </div>
    <div class="flex flex-row flex-shrink justify-center mt-4">
      <div
        v-for="(item, index) in scrollerItems"
        v-bind:key="index"
        class="flex"
      >
        <img :src="item.active ? selectedDot : unselectedDot" />
      </div>
    </div>
    <div class="mt-3">
      <div
        v-for="(item, index) in scrollerItems"
        v-bind:key="index"
        v-bind:class="item.active ? '' : 'hidden'"
      >
        <div class="text-qwellow text-14px font-Foco">
          {{ $t(item.header) }}
        </div>
        <div class="text-white text-14px">
          {{ $t(item.text) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const selectedDot = require('../../../assets/dot-checked.svg');
const unselectedDot = require('../../../assets/dot-unchecked.svg');

export default {
  name: 'CustomScroller',
  data() {
    return { selectedDot, unselectedDot, publicPath: process.env.BASE_URL };
  },
  props: ['scrollerItems'],
  methods: {
    first() {
      return this.activeIndex === 0;
    },
    last() {
      return this.activeIndex === this.scrollerItems.length - 1;
    },
    toLeft() {
      if (this.first()) {
        return;
      }
      const curActiveIndex = this.activeIndex;
      this.scrollerItems[curActiveIndex].active = false;
      this.scrollerItems[curActiveIndex - 1].active = true;
    },
    toRight() {
      if (this.last()) {
        return;
      }
      const curActiveIndex = this.activeIndex;
      this.scrollerItems[curActiveIndex].active = false;
      this.scrollerItems[curActiveIndex + 1].active = true;
    },
  },
  computed: {
    activeIndex() {
      return this.scrollerItems.findIndex(elem => elem.active);
    },
    image() {
      return this.scrollerItems[this.activeIndex].png;
    },
    webP() {
      return this.scrollerItems[this.activeIndex].webP;
    },
  },
};
</script>

<style scoped>
.a {
  fill: none;
  stroke: #fff;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2px;
}
.arrow {
  @apply rounded-full border-solid border-white w-8 h-8 bg-qwraysuperlight flex text-center;
}
.arr {
  fill: none;
  stroke: #a1b1b5;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2px;
}
.arr-disabled {
  stroke: #41565d;
}
.arr-wd {
  width: 18px;
}
</style>
